import { StepWizardObj } from '../../../../components/Elements/Modal/components/WizardHeader/WizardHeader.models'
import { ConnectionStatus, PLATFORMS, Platforms } from '../../models'
import i18n from 'Lib/i18n'

export interface ConnectionModalProps {
  onClose: () => void
  connectionStatus: ConnectionStatus
  isEnabled?: boolean
  editAccount?: number
  isEdit?: boolean
}

interface StepsObj {
  steps: StepWizardObj[]
}

export const googleSteps: StepWizardObj[] = [
  {
    stepNumber: 1,
    title: i18n.t('google-connection-wizard.step-1-title', { ns: 'PMPlatforms' }),
  },
  {
    stepNumber: 2,
    title: i18n.t('google-connection-wizard.step-2-title', { ns: 'PMPlatforms' }),
  },
  {
    stepNumber: 3,
    title: i18n.t('google-connection-wizard.step-3-title', { ns: 'PMPlatforms' }),
  },
]

export const metaSteps: StepWizardObj[] = [
  {
    stepNumber: 1,
    title: i18n.t('meta-connection-wizard.connect-account-title', { ns: 'PMPlatforms' }),
  },
  // DISABLED UNTIL FB APPROVES OUR APP, ON APPROVE - ALL STEPS and METHODS +1
  // {
  //   stepNumber: 2,
  //   title: i18n.t('meta-connection-wizard.select-business-manager-title', { ns: 'PMPlatforms' }),
  // },
  {
    stepNumber: 2,
    title: i18n.t('meta-connection-wizard.select-account-id-title', { ns: 'PMPlatforms' }),
  },
  {
    stepNumber: 3,
    title: i18n.t('meta-connection-wizard.select-pixel-id-title', { ns: 'PMPlatforms' }),
  },
  {
    stepNumber: 4,
    title: i18n.t('meta-connection-wizard.domain-to-pixel-title', { ns: 'PMPlatforms' }),
  },
  {
    stepNumber: 5,
    title: i18n.t('meta-connection-wizard.campaign-settings-title', { ns: 'PMPlatforms' }),
  },
  {
    stepNumber: 6,
    title: i18n.t('meta-connection-wizard.adsets-title', { ns: 'PMPlatforms' }),
  },
  {
    stepNumber: 7,
    title: i18n.t('', { ns: 'PMPlatforms' }),
  },
]

export const googleCampaignsSteps: StepWizardObj[] = [
  {
    stepNumber: 1,
    title: i18n.t('google-campaigns-wizard.protection-title', { ns: 'PMPlatforms' }),
  },
  {
    stepNumber: 2,
    title: i18n.t('google-campaigns-wizard.campaign-selection-header', { ns: 'PMPlatforms' }),
  },
  {
    stepNumber: 3,
    title: i18n.t('google-campaigns-wizard.success-header', { ns: 'PMPlatforms' }),
  },
]

export const metaCampaignsSteps: StepWizardObj[] = [
  {
    stepNumber: 1,
    title: i18n.t('meta-campaigns-wizard.protection-title', { ns: 'PMPlatforms' }),
  },
  {
    stepNumber: 2,
    title: i18n.t('meta-campaigns-wizard.campaign-selection-header', { ns: 'PMPlatforms' }),
  },
  {
    stepNumber: 3,
    title: i18n.t('meta-campaigns-wizard.success-header', { ns: 'PMPlatforms' }),
  },
]

export const platformWizardSteps: Record<Platforms, StepsObj> = {
  google: {
    steps: googleSteps,
  },
  meta: {
    steps: metaSteps,
  },
  microsoft: {
    steps: [],
  },
}

export const campaignsWizardSteps: Record<Platforms, StepsObj> = {
  google: {
    steps: googleCampaignsSteps,
  },
  meta: {
    steps: metaCampaignsSteps,
  },
  microsoft: {
    steps: [],
  },
}

export const PLATFORM_CONNECTION_CTA_BUTTON = {
  [PLATFORMS.MICROSOFT]: i18n.t('add-audience', { ns: 'PMPlatforms' }),
  [PLATFORMS.GOOGLE]: i18n.t('add-account', { ns: 'PMPlatforms' }),
  [PLATFORMS.META]: i18n.t('add-account', { ns: 'PMPlatforms' }),
}
